import { Component, Input } from '@angular/core';

@Component({
  selector: 'unread-messages',
  templateUrl: './unread-messages.component.html',
})
export class UnreadMessagesComponent {
  @Input() count: number;
}
